import { Button, Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import MainLayout from "../../components/layouts/mainLayout";
import { resetPassword } from "../../firebase/firebaseutils";
import TextField from "@mui/material/TextField";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const background = "/assets/login/auth-bg.webp";

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = () => {
    let res = resetPassword(email);
    res.then((value) => {
      if (value) {
        alert("Link sent");
      } else {
        setError("Invalid email address");
      }
    });
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "100% 100%, cover",
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          maxWidth: "1920px",
        }}
      >
        <MainLayout>
          <div
            style={{
              // width: "500px",
              // height: "500px",
              background: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexFlow: "column",
              paddingLeft: "32px",
              paddingRight: "32px",
              paddingTop: "32px",
              paddingBottom: "32px",
              // background: "#FBFAFA",
              flexDirection: "column",
              borderRadius: "8px",
            }}
          >
            <form
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexFlow: "column",
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: 600,
                  marginBottom: "10px",
                  marginTop: "10px",
                  color: "#610000",
                }}
              >
                Forgot Password
              </Typography>
              <TextField
                // type="email"
                // required
                value={email}
                onChange={handleEmail}
                // placeholder="Enter your email"
                variant="outlined"
                label="Enter your registered email"
                sx={{ width: "20rem" }}
              />

              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{
                  marginTop: "20px",
                  background: "#610000",
                  "&:hover": {
                    backgroundColor: "#813333",
                  },
                }}
              >
                SUBMIT
              </Button>
            </form>
            {error ? <p>Invalid Email</p> : ""}
          </div>
        </MainLayout>
      </div>
    </div>
  );
};

export default ForgotPassword;
